<template>
  <Modal v-model="visible" :mask-closable="false" title="份额更新记录" :footer-hide="true" :styles="{ top: '5vh' }" width="850px" class="my-modal">
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData"> </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
  </Modal>
</template>
<script>
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  data: () => ({
    visible: false,
    loading: false,
    merId: '',
    id: '',
    columns: []
  }),
  components: {},
  created() {
    this.columns = [
      {
        title: '操作人',
        key: 'createName',
        align: 'center',
        width: 150
      },
      {
        title: '变动前剩余份额',
        key: 'oldRemainNum',
        align: 'center',
        width: 110
      },
      {
        title: '变动后剩余份额',
        key: 'newRemainNum',
        align: 'center',
        width: 110
      },
      {
        title: '变动份额',
        key: 'changeNum',
        align: 'center',
        width: 130,
        render(h, pramas) {
          const num = pramas.row.oldRemainNum - pramas.row.newRemainNum;
          const text = `${num < 0 ? '增加' : '减少'}${Math.abs(num)}次`;
          return <div>{text}</div>;
        }
      },
      {
        title: '类型',
        key: 'changeNum',
        align: 'center',
        width: 110,
        render(h, pramas) {
          const statusMap = {
            '1': '初始分配',
            '2': '增加',
            '3': '减少',
            '4': '禁用',
            '5': '启用',
            '6': '分享使用',
            '7': '过期返回'
          };
          return <div>{statusMap[pramas.row.updateType]}</div>;
        }
      },
      {
        title: '更新时间',
        key: 'createTime',
        align: 'center'
      }
    ];
  },
  methods: {
    open(data) {
      this.searchParams = {
        joinId: data.id,
        type: 2 //运营传1，商户的传2
      };
      this.visible = true;
      this.initListAjax('/buz/giveawayProduct/queryUpdateRecord');
    }
  }
};
</script>
<style lang='scss' scoped>
.my-modal /deep/ {
  .table-box {
    margin-top: 30px;
  }
}
</style>
